import {
  cubeAdminCustomersWithAvailabilityRegionDimension,
  cubeAdminCustomersWithAvailabilityTotalMeasure,
  cubeAdminCustomersWithAvailabilityWithAvailMeasure,
} from "./cubeAdminCustomersWithAvailabilityModel";

export type CustomerAvailabilityByRegionRow = {
  region: string;
  total: number;
  withAvailability: number;
};

const isRecord = (v: unknown): v is Record<string, unknown> => typeof v === "object" && v !== null;

const readRegion = (v: unknown): string => {
  if (typeof v === "string" && v.length > 0) {
    return v;
  }
  return "—";
};

const readNumber = (v: unknown): number => {
  if (typeof v === "number" && !Number.isNaN(v)) {
    return v;
  }
  if (typeof v === "string" && v.length > 0) {
    const n = Number(v);
    if (!Number.isNaN(n)) {
      return n;
    }
  }
  return 0;
};

export const parseCustomerAvailabilityByRegionRows = (rows: unknown[]): CustomerAvailabilityByRegionRow[] => {
  const out: CustomerAvailabilityByRegionRow[] = [];
  for (const item of rows) {
    if (!isRecord(item)) {
      continue;
    }
    const region = readRegion(item[cubeAdminCustomersWithAvailabilityRegionDimension]);
    const total = readNumber(item[cubeAdminCustomersWithAvailabilityTotalMeasure]);
    const withAvailability = readNumber(item[cubeAdminCustomersWithAvailabilityWithAvailMeasure]);
    out.push({ region, total, withAvailability });
  }
  return out;
};
